module.exports = __webpack_public_path__ + "img/Qinghai-power.59ae7cda.png";